export default __webpack_public_path__ + "static/media/markdown.07e3b35d.svg";